<div>
    <p-toast />
  <!-- *ngIf="atividadeOSsVinculadas !== undefined && atividadeOSsVinculadas.length > 0" -->
  <p-table
    styleClass="p-datatable-gridlines"
    [value]="atividadeOSsVinculadas"
    [scrollable]="true"
    scrollHeight="600px"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr class="font-grid-os-vinculada-header">
        <th style="font-weight: bold">Data Solicitação</th>
        <th style="font-weight: bold">Serviço Complementar</th>
        <th style="font-weight: bold">Observação</th>
        <th style="font-weight: bold">Tipo de Execução</th>
        <th style="font-weight: bold">Status</th>
        <th style="font-weight: bold">Equipe</th>
        <th style="font-weight: bold">Usuário de Aprovação</th>
        <th style="font-weight: bold">Obs. da Aprovação</th>
        <th style="font-weight: bold">Data da Aprovação</th>
        <th style="font-weight: bold">Data de envio SICOM</th>
        <th style="font-weight: bold">Retorno SICOM</th>
        <th class="text-center" style="width: 8%">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-atividadeOSsVinculadas>
      <tr class="font-grid-os-vinculada">
        <td>{{ atividadeOSsVinculadas.dataSolicitacao | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ atividadeOSsVinculadas.servicoComplementar }}</td>
        <td>{{ atividadeOSsVinculadas.observacao }}</td>
        <td>{{ atividadeOSsVinculadas.tipoExecucao }}</td>
        <td>{{ atividadeOSsVinculadas.status }}</td>
        <td>{{ atividadeOSsVinculadas.nomeEquipe }}</td>
        <td>{{ atividadeOSsVinculadas.usuarioAprovacao }}</td>
        <td>{{ atividadeOSsVinculadas.observacaoAprovacao }}</td>
        <td>{{ atividadeOSsVinculadas.dataAprovacao | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ atividadeOSsVinculadas.dataEnvioSicom | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ atividadeOSsVinculadas.retornoSicom }}</td>
        <td class="text-center">
          <button
            pButton
            pRipple
            icon="pi pi-pencil"
            style="width: 30px; height: 30px; font-size: 10px"
            class="p-button-rounded p-button-success m-1"
            pTooltip="Editar OS Vinculada"
            title="Editar Os Vinculada"
            (click)="showDialog(atividadeOSsVinculadas)"
            [disabled]="
            atividadeOSsVinculadas.status === 'Aprovada' || atividadeOSsVinculadas.status === 'Recusada'"
          ></button>

        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DIALOG OS VINCULADA -->

  <p-dialog
    header="Dados da Solicitação de OS Complementar"
    [modal]="true"
    [(visible)]="displayDialog"
    [style]="{ width: '60rem' }"
  >
  <div>
    <div class="flex col-12 gap-6 mb-3">
      <div class="col-6">
        <label class="font-bold">Equipe:</label>
        <div class="mb-3">{{ detailOsComplementar?.nomeEquipe }}</div>
      </div>
      <div class="col-3">
        <label class="font-bold">Os de Origem:</label>
        <div class="mb-3">{{ detailOsComplementar?.numeroBaOrigem }}</div>
      </div>
      <div class="col-3">
        <label class="font-bold">Data da Solicitação:</label>
        <div class="mb-3">{{ detailOsComplementar?.dataSolicitacao | date : 'dd/MM/yyyy HH:mm:ss' }}</div>
      </div>
    </div>
    <div class="flex col-12 gap-6 mb-3">
      <div class="col-3">
        <label class="font-bold">Latitude:</label>
        <div class="mb-3">{{ detailOsComplementar?.latitude }}</div>
      </div>
      <div class="col-3">
        <label class="font-bold">Longitude</label>
        <div class="mb-3">{{ detailOsComplementar?.longitude }}</div>
      </div>
      <div class="col-3">
        <label class="font-bold">Tipo de execução:</label>
        <div class="mb-3">{{ detailOsComplementar?.tipoExecucao }}</div>
      </div>
    </div>
    <div class="flex col-12 gap-6 mb-3">
      <div class="col-12">
        <label class="font-bold">Observação:</label>
        <div class="mb-3">{{ detailOsComplementar?.observacao }}</div>
      </div>
    </div>

    <div class="flex col-12 gap-6 mb-3">
      <div class="col-8">
        <label class="font-bold">Serviço Complementar:</label>
        <div class="mb-3">{{ detailOsComplementar?.servicoComplementar }}</div>
      </div>
      <div class="col-3">
        <label class="font-bold">Status:</label><br />
        <p-select
          [options]="comboComplementar"
          [(ngModel)]="valueCombo"
          optionLabel="text"
          placeholder="Selecione o Status"
          [style]="{ width: '100%' }"
        />
      </div>
    </div>
  </div>
    <div class="col-12 mb-3">
      <label class="font-bold block mb-2">Observação da aprovação:</label>
      <textarea pTextarea [(ngModel)]="obsAprComplementar" [rows]="5" [autoResize]="true" class="w-full"></textarea>
    </div>

    <div class="flex justify-content-end mt-4 gap-2">
      <p-button
        icon="pi pi-times"
        label="Cancelar"
        severity="primary"
        variant="outlined"
        [style]="{width: '120px'}"
        (click)="this.displayDialog = false"
      ></p-button>

      <p-button
        icon="pi pi-save"
        label="Salvar"
        severity="primary"
        (click)="updOSComplementar()"
        pTooltip="Salvar"
        tooltipPosition="top"
        [style]="{width: '120px'}"
      ></p-button>
    </div>
  </p-dialog>
</div>
